import { render } from "./AddDescription.vue?vue&type=template&id=15fd9215&scoped=true&ts=true"
import script from "./AddDescription.vue?vue&type=script&lang=ts"
export * from "./AddDescription.vue?vue&type=script&lang=ts"

import "./AddDescription.vue?vue&type=style&index=0&id=15fd9215&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15fd9215"]])

export default __exports__